/* eslint-disable no-unused-vars */

import $ from 'jquery';
import tilt from 'tilt.js/dest/tilt.jquery';
import debounce from 'lodash.debounce';
import isIE from '../utils/isIE';
import { Component } from '../core/component';

export class TiltAnimation extends Component {
    constructor() {
        super();
        this.selector = '[data-tilt]';
    }

    init() {
        const body = document.getElementsByTagName('body')[0];
        const classScrolling = 'is-scrolling';
        const tilts = $(this.selector).tilt({
            maxTilt: 4,
        });

        if (isIE()) {
            tilts.tilt.destroy.call(tilts);
        } else {
            // when scrolling add class on body
            window.addEventListener(
                'scroll',
                debounce(() => {
                    // console.log('scrolling');
                    if (!body.classList.contains(classScrolling)) {
                        body.classList.add(classScrolling);
                    }
                }, 80, {
                    leading: true,
                    trailing: false,
                }),
            );

            // once stopped remove class
            window.addEventListener(
                'scroll',
                debounce(() => {
                    // console.log('stopped scrolling');
                    body.classList.remove(classScrolling);
                }, 80),
            );
        }

        // tilts.on('change', callback);
        // tilts.on('tilt.mouseLeave', callback);
        // tilts.on('tilt.mouseEnter', callback);
    }
}
